/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Export_DryInputs */

const cs_portals_export_dry = /** @type {(inputs: Portals_Export_DryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dry-run export`)
};

const en_portals_export_dry = /** @type {(inputs: Portals_Export_DryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dry-run export`)
};

/**
* | output |
* | --- |
* | "Dry-run export" |
*
* @param {Portals_Export_DryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_export_dry = /** @type {((inputs?: Portals_Export_DryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Export_DryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_export_dry(inputs)
	return cs_portals_export_dry(inputs)
});